<div class="panel-group" id="accordion">
    <ng-container *ngFor="let qdata of faqData; let i = index">
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title" data-toggle="collapse" [attr.data-target]="'#collapse' + i"
                    innerHTML="{{ qdata.Question}}">
                </h4>
            </div>
            <div [id]="'collapse' + i" class="panel-collapse collapse">
                <div class="panel-body" innerHTML="{{ qdata.Answer }}">
                </div>
            </div>
        </div>
    </ng-container>
</div>